import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { ReactNode } from "react";
interface Props {
	children?: ReactNode;
	dangerouslySetInnerHTML?:
		| {
				__html: string;
		  }
		| undefined;
}
export const PostSection = (props: Props) => {
	const theme = useTheme();

	const Section = styled("div")`
		.post-section {
			position: relative;
			display: flex;
			flex-direction: column;
			min-width: 0;
			word-wrap: break-word;

			border-radius: 25px;
			overflow: hidden;
			background: ${theme.dark100};
			flex: 1 1 auto;
			padding: 0;
			width: 100%;
			box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.13);

			a {
				font-family: inherit;
				letter-spacing: inherit;
			}

			&:before {
				position: absolute;
				top: 0;
				left: 0;
				z-index: 0;
				content: "";
				background: linear-gradient(
					135deg,
					rgba(0, 0, 0, 0) 0%,
					rgba(0, 0, 0, 0.4) 100%
				);
				width: 100%;
				height: 100%;
				background-size: cover;
			}
			margin-bottom: 25px;
			.post-section-content {
				position: relative;
				z-index: 1;
				padding: 1.5rem;
				> *:last-child {
					margin-bottom: 0;
				}
				hr {
					border-color: transparent;
				}
				> .new-mod {
					display: flex;
					flex-direction: row;
					justify-content: space-between;

					> img {
						width: 33%;
						height: auto;
						align-self: center;
						padding-right: 30px;
					}
					.new-mod-content {
						width: calc(100% - 265px);
					}
				}
			}
		}
	`;

	return <Section {...props}>{props.children}</Section>;
};
